// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
import OHSMultiTab from '../../../../onehivesystems/js/OHSMultiTab';
// Assets
import './BulkActions.scss';
import FindAndReplace from './Modules/FindAndReplace';


// COMPONENT
export default function BulkActions (props) {
   // States and Variables
   const [fields, setFields] = useState(null);
   const [devices, setDevices] = useState(null);

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Bulk Actions"); // set page title
      getFields();
      getDevices();
   }, []);

   // Functions
   const getFields = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'GET',
         success: function (data) {
            setFields(data);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getDevices = function () {
      OHSCRUD({
         url: '/v1/oneport/devices',
         method: 'GET',
         success: function (data) {
            setDevices(data);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }

   // Component
   return (
      <div className="oneport-bulkactions">
         <OHSAppHeader onehive={props.onehive} title="Bulk Actions" help="https://www.onehivesystems.com/documentation/oneport/bulkactions" />
         <OHSAppBody onehive={props.onehive}>
            <OHSMultiTab onehive={props.onehive} content={[
               {
                  title: "Find and Replace",
                  content: <FindAndReplace onehive={props.onehive} parent={{
                     fields: fields,
                     setFields: setFields,
                     devices: devices,
                     setDevices: setDevices
                  }} />
               }
            ]} />
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}